import React, { useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getResponseError, setFormError } from '../../../utils/utils';
import { FORM_VALIDATION_MESSAGE } from '../../../utils/apiError';
import { createProvider, editProviderById } from '../actions';
import Loader from '../../../components/base/Loader/Loader';
import { getProviderData } from '../reducer';
import ProviderDTO from '../../../dto/ProviderDTO';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import TextPasswordInput from '../../../components/fields/TextInput/TextPasswordInput';

const getProviderDefaults = provider => ({
  ...(provider || {}),
  provider_name: provider?.provider_name || provider?.name || '',
  token: '',
});

export default function ProviderForm(props) {
  const {
    onClose = () => {},
    loadData = () => {},
    currentProvider = null,
    isReadOnly = false,
  } = props;
  const { loadingCreateProvider, loadingEditProviderById } = useSelector(getProviderData);
  const dispatch = useDispatch();
  const {
    reset, control, getValues, setError,
  } = useForm({
    mode: 'onChange',
    defaultValues: getProviderDefaults(currentProvider),
  });

  useEffect(() => {
    reset(getProviderDefaults(currentProvider));
  }, [currentProvider, reset]);

  const handleSave = () => {
    const values = getValues();
    const providerName = values.provider_name?.trim();
    const token = values.token?.trim();

    if (!providerName) {
      setError('provider_name', { type: 'manual', message: 'Введите название провайдера' }, { shouldFocus: true });
      errorNotification('Сохранение формы', FORM_VALIDATION_MESSAGE);
      return;
    }

    if (!currentProvider?.id && !token) {
      setError('token', { type: 'manual', message: 'Введите токен провайдера' }, { shouldFocus: true });
      errorNotification('Сохранение формы', FORM_VALIDATION_MESSAGE);
      return;
    }

    const payload = {
      provider_name: providerName,
    };

    if (token) {
      payload.token = token;
    }

    const action = currentProvider?.id ? editProviderById({ ...payload, id: currentProvider.id }) : createProvider(payload);
    dispatch(action)
      .then(() => {
        successNotification('Сохранение формы', 'Форма сохранена');
        loadData();
        onClose();
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение формы', getResponseError(response));
      });
  };

  const dto = new ProviderDTO();
  const attributes = dto.getAttributesByName();

  return ReactDOM.createPortal(
    <div className="form-dialog provider-form">
      <Loader loading={loadingCreateProvider || loadingEditProviderById} />
      <div className="form-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev">Провайдеры</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current">Провайдер № {currentProvider?.id || 'Без номера'}</span>
          <span className="breadcrumbs-current">
            {` (${isReadOnly ? 'просмотр' : (currentProvider?.id ? 'редактирование' : 'создание')}) `}
          </span>

        </div>
        <div className="close-button" onClick={onClose}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="form-body">
        <form className="form-content">
          <div className="form-fields">
            <div className="form-fields-wrapper custom-scroll-theme">
              <div className="afc-body">
                <div className="afc-main provider-main-info">
                  <Row className="row-cols-1">
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={TextInputWithLabel}
                      dtoObject={attributes.provider_name}
                      variant="material"
                      inputProps={{
                        disabled: isReadOnly,
                      }}
                      withLabel
                      className="mb-3"
                    />
                  </Row>
                  <Row className="row-cols-1">
                    <FieldDTOWithCol
                      control={control}
                      component={TextPasswordInput}
                      dtoObject={attributes.token}
                      variant="material"
                      inputProps={{
                        disabled: isReadOnly,
                      }}
                      withLabel
                      textMuted={currentProvider?.id && !isReadOnly ? 'Оставьте поле пустым, чтобы не менять текущий токен' : ''}
                      className="mb-3"
                    />
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <div className="form-footer">
            {isReadOnly ? null : <Button onClick={() => handleSave()}>{currentProvider?.id ? 'Сохранить' : 'Создать'}</Button>}
            <Button variant="secondary" onClick={onClose}>Отменить</Button>
          </div>
        </form>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
